import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { Observable } from 'rxjs';
import { MARKET_SELECTOR_SERVICE_TOKEN, Market, MarketSelectorServiceInterface } from './tokens';

@Component({
  selector: 'sales-ui-market-selector',
  templateUrl: './market-selector.component.html',
  styleUrls: [],
  standalone: false,
})
export class MarketSelectorComponent {
  @Output() selectedMarketIdChange = new EventEmitter();
  marketDropdownOptions$: Observable<Market[]>;
  selectedMarketId$: Observable<string>;
  constructor(@Inject(MARKET_SELECTOR_SERVICE_TOKEN) private marketSelectorService: MarketSelectorServiceInterface) {
    this.marketDropdownOptions$ = marketSelectorService.marketDropdownOptions$;
    this.selectedMarketId$ = marketSelectorService.selectedMarketId$;
  }

  handleMarketIdChange(selectedMarket: MatSelectChange): void {
    this.marketSelectorService.setSelectedMarketId(selectedMarket?.value);
    this.selectedMarketIdChange.emit();
  }
}
